module.exports = __webpack_public_path__ + "img/introduction-pos-system-ilustra.e49b3de9.png";